import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Publish extends React.PureComponent {

  static propTypes = {
    formdata: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  state = {
    config: {}
  }

  formRef = React.createRef()

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { config } = this.state
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Finish)', color: 'blue', handler: this._handleSubmit }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            {
              label: 't(Publish)', 
              type: 'segment',
              fields: [
                {
                  name: 'strategy',
                  type: 'radiogroup',
                  options: [
                    { value: 'draft', text: 't(Dont publish announcement)' },
                    { value: 'publish', text: 't(Publish announcement)' },
                    { value: 'schedule', text: 't(Schedule announcement)' }
                  ],
                  defaultValue: 'draft'    
                },
                { 
                  name: 'send_at', 
                  type: 'datetimefield', 
                  show: config.strategy === 'schedule', 
                  required: true 
                }
              ]
            }
          ]
        }
      ]
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(announcement) {
    this.props.onSave(announcement)
  }

}

export default Publish
